const fr= {
    aftersales:{
        "contactus":"contactez -nous pour une réponse rapide",
        "workorder":"l'ordre de travail ",
        "createjob":"créer une ordre",
        "submittinworkorder":"Lorsque vous soumettez un ordre de travail, veuillez inclure autant d'informations détaillées que possible, telles que des captures d'écran de l'erreur, des informations sur le compte, etc.",
        "workordercontent":"le contenu de l'oeuvre ",
        "subscriptionaccount":"comptes d'abonnement",
        "problemtype":"types de problèmes ",
        "tobeprocessed":"en attente de traitement ",
        "processed":"déjà traité ",
        "revoked":"annuler",
        "create":"créer",
        "workorderno":"numéro d'ordre de travail",
        "product":"produit",
        "status":"statut",
        "type":"type",
        "ticket":"l'ordre  de travail",
        "createtime":"le temps de créer",
        "reply":"réponse",
        "operate":'opération ',
        "onlinechat":"chat en ligne",
        "resolveworkorder":"Nous le résoudrons dès que possible après avoir soumis votre bon de travail",
        "noworkorder":"Aucun bon de travail",
        "revoke":"Révoquer",
        "content":"Contenu"
        
    },
    excode:{
        "redemptioncode":"code d'échange",
        "pleaseredemptioncode":"entrez le code d'échange s'il vous plaît",
        "exchange":"échange",
        "notused":"inutilisé",
        "used":"utilisé",
        "expired":"périmé",
        "status":"Statut",
        "exchangetime":"le temps d'échange",
        "createtime":"le temps de créer",
        "selectactivityarea":"Veuillez sélectionner le domaine d'activité",
        "optionaltraintickets":"Billets optionnels",
        "newpurchase":"Nouvel achat",
        "renew":"Renouvellement"
    },
    header:{
        "personaldetails":"informations personnelles"
    },
    footer:{
        "contactus":"contactez -nous",
        "navigation":"navigation bar",
        "home":"page d'accueil",
        "friends":"avec nos amis",
        "subscribe":"s'abonner",
        "aftersales":"après-vente ",
        "help":"aider",
        "termsofuse":"conditions d'utilisation",
        "refundpolicy":"Politique de remboursement",
        "privacypolicy":"Politique de confidentialité ",
        "paymentmethod":"modes de paiement",
        "language":"langue",
        "map":"plan du site",
        "homescreen":"Écran d'accueil",
        "setpreferences":"Définissez vos préférences",
        "setlanguage":"Veuillez définir votre langue"
    },
    friends:{
        "promotioninfo":"informations de rabais",
        "currentlevel":"niveau actuel",
        "content":"Vous pouvez utiliser des liens promotionnels exclusifs et des codes de réduction à partager avec d'autres pour gagner des commissions. Plus le niveau est élevé, plus la commission est importante.",
        "rolemembers":"Vous pouvez inviter vos amis et plus le niveau est élevé, plus vous bénéficiez de réductions et de prix.",
        "promotionallinks":"promotion des liens",
        "discountcodes":"le code de rabais",
        "copy":"copier",
        "rebateratio":"Pourcentage de commission",
        "discountratio":"Pourcentage de rabais",
        "lowestdiscountratio":"rabais le plus bas",
        "walletsandpoints":"Portefeuille et points",
        "applywithdrawal":"Après votre demande de retrait, nous l'examinerons et effectuerons le paiement dans un délai de trois jours ouvrables.",
        "withdraw":"retirer",
        "record":"registre des retraits",
        "integral":"point",
        "pointsused":"Les points peuvent être utilisés pour des tirages au sort",
        "orderdetails":"détails de l'ordre",
        "orderamount":"le montant de l'ordre",
        "earnings":"profit",
        "withdrawalsrecord":"Registre des retraits",
        "accounts":"Nom d'utilisateur",
        "accounttype":"type de compte",
        "withdrawalamount":"le montant à retirer",
        "cancel":"annuler",
        "submit":"soumettre",
        "greaterthan":"le montant du retrait doit être supérieur à 30",
        "normal":"normal",
        "invalid":"inefficacité",
        "bankcard":"carte bancaire",
        "promotionlink":"promotion des liens",
        "discountcode":"numéro de rabais",
        "waitingforapproval":"en cours d'examen",
        "waitingforpayment":"en attente de paiement",
        "notpass":"non passe",
        "paid":"payé",

        "cashwithdrawalid":"numéro de retrait",
        "accountsreceivable":"comptes débiteurs",
        "amount":"comptes débiteurs(USD)",
        "status":"état",
        "applicationtime":"le temps d'application",
        "processingresults":"le résultat du traitement",

        "sku":"상품",
        "orderid":"numéro de commande",
        "useramount":"le numéro de compte de l'utilisateur",
        "duration":"durée de l'achat",
        "promotiontype":"type de promotion",
        "createtime":"le temps de créer",
        "eainings":"profit (USD)",

        "receivingaccount":"Compte de réception",
        "nowithdrawableamount":"n'ont pas d'argent liquide à retirer",
        "copysuccessfully":"Succès de copie",
        "copyfailed":"échec de copie",
        "salesvolume":"Volume des ventes",
        "nodata":"Aucune donnée pour l'instant"
    },
    home:{
        'notice':'Click getNfcode to resolve unable to sign in Netflix',
        'join':'Ouvrez votre abonnement partagé à un prix inférieur',
        'Renewal':'Renew',
        "texttitle":" ",// 原内日：저가 공유 구독 更新
        "buynow":"acheter maintenant",
        "soldout":"les abonnements sont épuisés",
        "delivery":"paiements en temps réel",
        "after":"le paiement est suivi d'une livraison en temps réel sans attente.",
        "certificate":"certificat SSL",
        "payments":"environnement de paiement sécurisé avec certification SSL.",
        "onlinesupport":"7*24h service client en ligne",
        "privatecustomer":"7*24h service client privé  en ligne",
        "subscriber":"droits pour les clients abonnés",
        "subscriptions":"Abonnements partagés à bas prix avec priorité aux co-abonnés dans le même pays",
        "moneyback":"garantie de remboursement",
        "refund":"vous avez d'un délai de 1-20 jours pour demander un remboursement (YouTube Premium dans les 7 jours, lisez la politique de remboursement pour plus d'informations)",
        "parkingspace":"place de stationnement",
        "gift":"cadeau",
        "screen":"sous-compte",
        "1screen":"une sous-compte ",
        "maxnum":"sous-compte",
        "month":"mois",
        "buytyp":"Type d'achat",
        "subscription":"s'abonner",
        "voucher":"coupon",
        "discountcode":"numéro de rabais",
        "use":"utiliser",
        "paymentmethod":"mode de paiement",
        "pleasechoose":"choisissez s'il vous plaît",
        "billingdetails":"détail de facturation",
        "payaddress":"l'adresse détaillée de facturation",
        "firstname":"nom de famille ",
        "lastname":"prénom",
        "emailaddress":"l'adresse e-mail",
        "phone":"téléphone",
        "country":"pays",
        "state":"province",
        "city":"cité",
        "address":"l'adresse de la rue",
        "housenumber":"numéro de la rue",
        "suiteunit":"Appartement, suite, unité, etc. (facultatif)",
        "zipcode":"code postal ",
        "submit":"soumettre",
        "creditcard":"carte bancaire",
        "cardnumber":"numéro de carte ",
        "expirydate":"délai d'expiration",
        "nameoncard":"nom du titulaire de la carte",
        "savethiscard":"Sauvegarder cette carte pour des paiements futurs",
        "play":"soumettre",
        "emailerror":"erreur d'e-mail",
        "payresluttitle":"Paiement réussi",
        "Pleaseconfirmsuk":"vérifiez les informations sur le produit s'il vous plaît",
        "buytips": "Nous sommes un compte familial partagé. Un achat ne peut être effectué que par une seule personne.\n"+
        "Après avoir effectué votre achat de Youtube, entrezvotre adresse électronique sur la page d'abonnement s’il vous plaît .",
        "pleaseenter":"entrez s'il vous  plaît",
        "selectamonth":"choisissez  le mois s'il vous plaît",
        "selectthenumber":"choisissez le numéro de sous-compte s'il vous plaît",
        "selectthepurchase":"choisissez le type d'achat s'il vous plaît",
        "selectthepayment":"choisissez la mode de paiement s'il vous plaît",
        "discountcodenotempty":"le code postal ne peut pas être vide!",
        "detail1":
        // "<p>✅ 넷플릭스 정책 변화에 영향을 받지 않고 사용할 수 있습니다.</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>5 personnes partagent un compte.</span> </p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>téléphone / ordinateur / télévision</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K / HDR / Dolby</span></p>"+
            "<p><i class=\"el-icon-check\"></i><span>en cas de problème, nous vous remboursons.</span></p>\n",
        "detail2":"<p><i class=\"el-icon-check\"></i><span>plan premium/sous-compte</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>son de haute qualité</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>livraison en temps réel</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>téléphone , PC, Tab</span></p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: 110px; top: 77.3906px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail3":"<p><i class=\"el-icon-check\"></i><span>plan premium/sous-compte</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>6 personnes partagent un compte</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>téléphone, ordinateur,TV</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Registres privés de visionnage de films.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>gardez vos préférence et listes</span></p>",
        "detail5":"<p><i class=\"el-icon-check\"></i><span>plan premium/sous-compte</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>ennoyez des liens d'invitation en temps réel</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>entrez votre adresse électronique sur la page d'abonnement s’il vous plaît.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Vous pouvez utiliser votre compte existant.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>gardez vos préférence et listes</span></p>\n" +
            // "<p>✅ 도움말: 구매하기 전에 play.google.com에서 계정 국가가 KR, ES, FR, PL, IT, DE, NL, GB, CA, US, JP, GR, CH, LT, PA, SG, , CZ, SE, PT, BE, IL 인지 확인하세요.</p>\n" +
            "<div id=\"gtx-trans\" style=\"position: absolute; left: -51px; top: 143.094px;\">\n" +
            "<div class=\"gtx-trans-icon\">&nbsp;</div>\n" +
            "</div>",
        "detail7":"<p><i class=\"el-icon-check\"></i><span>renouvelez le même abonnement</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>gardez vos préférence et listes</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>livraison en temps réel</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Garantie de remboursement</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Avant d'acheter, veuillez ouvrir le lien suivant https://www.max.com/ pour voir si le max est disponible.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Abonnement au partage. Pour 1 seule vue d'écran (1/4)</span></p>",
        "detail8":"<p><i class=\"el-icon-check\"></i><span>modèle officiel</span></p>\n" +
            // "<p>✅ des magasins GPT sont disponible</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>des plug-ins sont disponible</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>api ne peut pas être utilisée</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>les chats sont protégés et ne peuvent pas être consultés par d'autres personnes.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Services intégrés de comptes gpt multiples, commutation à volonté</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>le service après-vente peut en charge les remboursements 24h sur 24 sans soucis</span></p>",
        "detail9":"<p><i class=\"el-icon-check\"></i><span>Abonnement au partage. Pour 1 seule vue d'écran (1/4)</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>livraison en temps réel</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>téléphone, ordinateur,TV</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>4K / HDR / Dolby</span></p>",
        "detail10":"<p><i class=\"el-icon-check\"></i><span>plan premium/sous-compte</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>téléphone, ordinateur,TV</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>livraison en temps réel</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>gardez vos préférence et listes.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Garantie de remboursement</span></p>",
        "detail11":"<p><i class=\"el-icon-check\"></i><span>Compte séparé.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Un compte qu’une seule personne peut utiliser.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Abonnement privé, conservez tout.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Non affecté par les politiques de Netflix.</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Pas de code, le code de vérification apparaîtra</span></p>",
        "detail12":"<p><i class=\"el-icon-check\"></i> <span>Pas de compte ChatGPT requis</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Messages de chat protégés</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Prise en charge de GPT-cho et GPT-cho-mini</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Prise en charge de GPT-4.1, GPT-4.5, GPT-o3</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i> <span>Des serveurs hautes performances garantissent votre accès stable</span></p>",
        "detail13":
            "<p><i class=\"el-icon-check\"></i><span>Plan Education Plus (hors Notion AI)</p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Liberté modulaire: Elimine la confusion liée au changement d'outil</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Workspace intégré: économie de 57% sur les outils</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Collaboration en temps réel: coordination sans retard</span></p>",
         "detail14":
            "<p><i class=\"el-icon-check\"></i><span>Disfruta de Super Duolingo</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Los miembros pueden disfrutar de un entorno de aprendizaje sin anuncios, evitando distracciones durante cada lección y enfocándose en el estudio</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Utilisez la fonction « Pratique personnalisée » pour corriger les erreurs pendant la pratique</span></p>\n" +
            "<p><i class=\"el-icon-check\"></i><span>Les membres peuvent défier le niveau de légende le plus élevé indéfiniment, maîtriser le contenu appris en profondeur et améliorer leurs compétences linguistiques</span></p>",
        "lowerpricesharelarge":"Partagez des abonnements premium à des prix inférieurs sur",
        "lowerpricesharesmall":"Partagez des abonnements premium à des prix inférieurs sur <span class='green-text-2'>AlongShare</span>",
        "highqualitystreaming":"Fournir une haute qualité et des prix bas pendant 3 années consécutives",
        "detail":"vérifier les détails",
        "moreactivities":"Beaucoup d'activités, beaucoup de gains",
        "sharejoinsubscription":"<span class='green-text-2'>Partager</span>Rejoindre la coopération",
        "shareyoursubscription":"Partager avec des amis",
        "availabletime":"Avec code de réduction exclusif",
        "makemoney":"Quelqu'un d'autre a acheté en utilisant votre code de réduction",
        "widerangesubscription":"Vous pouvez obtenir des remises sur les commandes correspondantes",
        "threestepsshare":"Les détails de la commande promotionnelle peuvent être consultés dans le panneau des commissions",
        "joinsubscription":"Rejoignez la coopération",
        "saveupsubscriptionfees":"Auto-publiez des articles/vidéos promotionnels sur Naver/YouTube/Telegram",
        "securepayment":"La promotion comprend son propre code de réduction",
        "manualreview":"Après la promotion, vous pouvez facilement vérifier l'état de la commande sur la page « 추천 할인 »",
        "oneclickjoin":"Vous pouvez retirer de l'argent lorsque votre portefeuille accumule 30 $.",
        "whyusealongshare":"Pourquoi <span class='green-text-2'> de plus en plus</span> de personnes utilisent <span class='green-text-2'> Alongshare</span>",
        "position":"{0} bits",
        "selectdiscount":"Sélectionnez la remise",
        "notstoreinfo":"AlongShare ne stocke pas les informations de votre carte. Toutes les transactions sont sécurisées, traitées et autorisées par un prestataire de paiement externe",
        "alumpsum":"paiement unique",
        "details":"Détails",
        "subtotal":"Total",
        "promotioncodescoupons":"Codes promotionnels et coupons",
        "paymentfee":"frais de paiement",
        "total":"total",
        "nowastediscount":"Ne gaspillez pas cette réduction !",
        "hoursjoin":"A rejoint il y a {hours} heures",
        "minutesjoin":"A rejoint il y a {minutes} minutes"
    },
    login:{
        "welcomelogin":"bienvenu à la connexion",
        "login":"se connecter",
        "updatepwd":" changer vôtre mot de passe",
        "reg":"créer un compte",
        "agreement":"Confirmez que vous avez lu et accepté nos conditions d'utilisation",
        "quicklogin":"connexion rapide",
        "sendcode":"envoyer un code de vérification",
        "register":"s'inscrire",
        "changepassword":"changer votre mot de passe",
        "verificationcode":"code de vérification",
        "name":"prénom",
        "password":"mot de passe",
        "agapassword":"entrez foutre mot de passe encore une fois",
        "modify":"changer",
        //"validatepswlen":"Les mots de passe doivent contenir des lettres majuscules, des lettres minuscules, des chiffres et des caractères spéciaux, ainsi que toute combinaison de trois d'entre eux, et avoir une longueur comprise entre 8 et 16 !",
        "validatepswlen":"Mot de passe doit contenir n'importe quelle lettre, chiffres, caractères spéciaux",
        "checkagreement":"vérifiez l'accord s'il vous plaît",
        "passwordinconsistency":"Mots de passe incohérents saisis deux fois!",
        "passwordagain":"entrez foutre mot de passe encore une fois s'il vous plaît",
        "verificationsend":"le code de vérification a été envoyé ,vérifiez s'il vous plaît.",
        "useemail":"ou utilisez votre email",
        "agree":"En continuant, vous acceptez notre",
        "and":"et",
        "andconfirm":"et confirmer",
        "readour":"Vous avez lu notre",
        "forgotpassword":"oublier le mot de passe",
        "codelogin":"Connectez-vous en utilisant le code de vérification",
        "verifyemail":"Vérifier l'e-mail",
        "sendcodeemail":"Nous enverrons un code de vérification par e-mail à Enter Verification Complete Registration {email}.",
        "continue":"continuer",
        "resend":"Renvoyer",
        "noreceivecode":"Vous ne pouvez pas accepter le code de vérification ?",
        "passwordlogin":"Connexion par mot de passe",
        "setpassword":"Définir le mot de passe",
        "confirmpassword":"Confirmez le mot de passe"
    },
    luckdraw:{
        "lotteryticket":"prix",
        "integral":"point",
        "welcome":"Voici la page de notre événement, cliquez sur la carte pour obtenir un tirage au sort en un seul clic.\n" +
            "Les prix comprennent divers comptes gratuits, des codes de réduction et d'autres remises.Merci pour votre soutien et votre confiance.",
        "none":"non",
        "redemptioncode":"code d'échange ",
        "copy":"copie",
        "prizelist":"liste de prix",
        "notused":"utilisé ",
        "used":"utiliser",
        "expired":"périmé",

        "prizeno":"numéro de prix",
        "contents":"contenu de prix",
        "exchangedate":"date d'echange/date d'utilisation ",
        "createtime":"le temps de créer",
        "exchange":"échange ",
        "insufficientpoints":"points insuffisants",
        "consumepoints":"cette opération coûtera 10 points. continuer?",
        "tips":"conseil",
        "comfirm":"confirmer ",
        "cancel":"annuler",
        "failtowin":"n'a pas gagné ",
        "congratulations":"félicitations pour l'avoir obtenu",
        "copysucceeded":"Succès de copie",
        "copyfailed":"échec de copie",
    },
    subscribe:{
        "clickto":"cliquez pour avoir le lien",
        "Resend":"obtenez le lien pour vous connecter",
        "getverificationlink":"renvoyez s'il vous plaît",
        "getlinktips":"si vous n'être pas invité à entrer un code de validation,ignorez-le.",
        "renewnow":"renouveler maintenant",
        "subscription":"renouveler le même abonnement",
        "independent":"4K+HDR HD, record d'observation indépendant",
        "guarantee":"Garantie de remboursement",
        "timeleft":"temps restant ",
        "openingtime":"heure de début du comte ",
        "endtime":"heure de fin",
        "account":"Nom d'utilisateur",
        "password":"mot de passe ",
        "profile":"profil ",
        "pleaseuse":"utilisez s'il vous plaît ",
        "subaccount":"sous-compte ",
        "myprofile":"mes informations personnelles ont été utilisé de manière illégitime!",
        "renew":"renouveler ",
        "aftersales":"service après-vente",
        
        "submitYoutube":"Après avoir entré votre adresse électronique, il vous suffit de cliquer sur le bouton 'Rejoindre' pour rejoindre le groupe familial. Ou vous pouvez également copier et ouvrir le lien vers le compte Google Chrome du compte que vous souhaitez rejoindre le groupe familial.",
        "yourownsub":"1.utilisez votre propre sous-compte en fonction du numéro de série s'il vous plaît ..",
        "delete":"2.ne modifiez pas et ne supprimez pas d'outre sous-compte s'il vous plaît ",
        "modifysubscription":"3. ne modifiez pas des informations d'abonnement",
        "reminder":"Conseil : Si vous rencontrez des problèmes, veuillez contacter le service clientèle, achetez un abonnement dans alongshare, bénéficiez du service clientèle VIP, renouvellement sans changement de numéro.",
    
        // "youtubeloginemail":"YouTube 로그인 이메일을 입력합니다. 로그인 이메일 주소를 사용하여 가족 그룹에 가입해야 합니다. 그렇지 않으면 가족에서 쫓겨날 것입니다. 도움이 필요하시면 Alongshare 고객 서비스에 이메일로 연락하십시오.",
        "youtubeloginemail":"Saisissez votre adresse électronique de connexion à YouTube. Veillez à utiliser votre adresse e-mail de connexion pour rejoindre le groupe familial, sinon vous serez expulsé de la famille. Si vous avez besoin d'aide, veuillez contacter le service clientèle d'Alongshare par courrier électronique à l'adresse suivante",
        "aftersalesservice":"service après-vente ",
        "support":"page de supporte .",
        "submit":"soumettre",
    
        "buyit":"il n'y a pas encore d'abonnement ,dépêchez -vous de l'acheter",
        "paymentsucceeded":"paiement réussi",
        "month":"choisissez le mois s'il vous plaît ",
        "number":"choisissez le nombre de sous-compte s'il vous plaît",
        "purchase":"choisissez le type d'achat s'il vous plaît",
        "payment":"choisissez la mode de paiement s'il vous plaît ",
        "name":"entrez le nom sur la carte s'il vous plaît",
        "card":"entrez le numéro de carte s'il vous plaît ",
        "cvv":"entrez CVV s'il vous plaît",
        "expirydate":"entrez le temps d'échéance s'il vous plaît ",
        "processing":"Le statut de traitement a été soumis. Vérifiez le statut de traitement du bon de travail.",
        "cannotempty":"le code de rabais ne peut pas être vide!",
        "originalpassword":"Le mot de passe original pour cette opération n'est plus utilisé. continuer ou non?",
        "passwordmeets":"Les mots de passe doivent contenir des lettres majuscules, des lettres minuscules, des chiffres et des caractères spéciaux, ainsi que toute combinaison de trois d'entre eux, et avoir une longueur comprise entre 8 et 16!"
    
    },
    userinfo:{
        "signout":"Sign out",
        "nickname":"Nickname",
        "avatar":"Avatar",
        "uploadavatar":"Please upload your avatar",
        "logout":"Are you sure you want to log out?",
        "onlyjpgpng":"Uploaded pictures can only be in JPG | png format",
        "cannotexceed":"The size of the uploaded image cannot exceed 5MB!",
        "exitalongshare":"Quitter le partage ?",
        "personaldata":"données personnelles",
        "clickimage":"Cliquez sur l'image pour la modifier",
        "edit":"modifier",
        "alongshareloginemail":"E-mail de connexion AlongShare",
        "save":"sauvegarder",
        "resetpassword":"réinitialiser le mot de passe",
        "editpassword":"modifier le mot de passe",
        "passwordmust":"Votre mot de passe doit avoir",
        "anycharacter":"Toutes les lettres, chiffres, caractères spéciaux",
        "twosamepasswords":"Les deux mots de passe que vous avez saisis sont les mêmes",
        "currentpassword":"Mot de passe actuel",
        "newpassword":"Nouveau mot de passe",
        "confirmpassword":"Confirmez le mot de passe",
        "updatepassword":"Mettre à jour le mot de passe"
    },
    wish:{
        "wish":"faire un vœux ",
        "help":"AlongShare choisit quelques vœux à réaliser",
        "christmas":"Laissez vos souhaits. Ils se réaliseront à Noël.",
        "submit":"soumettre",
        "mywish":"mes souhaits"
    },
    map:{
        "home":"page d'accueil",
        "userinfo":"informations d'utilisateur",
        "login":"se connecter",
        "withfriends":"avec nos amis",
        "subscribe":"s'abonner à",
        "aftersales":"service après-vente",
        "Luckdraw":"tirer au sort un prix",
        "wish":"faire un vœux",
        "helpcenter":"centre d'aide ",
        "tradingstamps":"page d'échange",
        "affiliateprogram":"programme d'affiliation",
        "order":"Commande"
    },
    order:{
        "whetherpayment":"S'il faut payer",
        "yes":"Oui",
        "no":"Non"
    }
}

export default fr
